import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.dtwin.id ? _c('div', [_c(VCard, {
    staticClass: "my-0 pa-0 dtwin-preview",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_vm.hasHeaderBG && _vm.headerBG && !_vm.showSkeletonLoader ? _c('div', [_c(VParallax, {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": _vm.parallaxHeight,
      "src": _vm.headerBG
    }
  })], 1) : _vm._e(), _vm.hasHeaderBG && !_vm.headerBG || _vm.showSkeletonLoader ? _c('div', [_c('div', {
    staticClass: "dtwin-detail-header",
    staticStyle: {
      "height": "143px"
    }
  })]) : _vm._e(), !_vm.hasHeaderBG ? _c('div', {
    staticStyle: {
      "height": "5px"
    }
  }) : _vm._e(), _c(VCardText, [_c(VRow, [_c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', {
    staticClass: "px-3 pb-0 my-0 dtwin-title-frame header-text text-truncate"
  }, [!_vm.showSkeletonLoader && _vm.dtwin.data.faIcon && _vm.dtwin.data.faIcon.trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.dtwin.data.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.dtwin.title) + "\n          ")], 1)])], 1), _vm.isDescription ? _c(VCardActions, {
    staticStyle: {
      "margin": "0px",
      "padding-bottom": "0px"
    }
  }, [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDescription = !_vm.showDescription;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.description')) + "\n        ")]), _c(VSpacer), _c(VBtn, {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDescription = !_vm.showDescription;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.showDescription ? 'fal fa-chevron-up' : 'fal fa-chevron-down'))])], 1)], 1) : _vm._e(), _c(VExpandTransition, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showDescription,
      expression: "showDescription"
    }]
  }, [_vm.isDescription ? _c(VDivider, {
    staticStyle: {
      "margin-left": "8px !important",
      "margin-right": "8px !important"
    }
  }) : _vm._e(), _vm.isDescription ? _c(VCardText, {
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.dtwin.data.description) + "\n          ")]) : _vm._e()], 1)]), _vm.twinDataStates !== null ? _c('div', {
    staticClass: "preview-tiles-container",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm.isObjEmpty(_vm.twinDataStates) && (_vm.showSkeletonLoader || _vm.loading) ? _c('div', {
    staticClass: "d-flex justify-center align-center"
  }, [_c(VProgressCircular, {
    attrs: {
      "size": 50,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })], 1) : _c('core-dtwin-state-preview-db-tiles', {
    attrs: {
      "twinDataStates": _vm.twinDataStates,
      "updatedStates": _vm.updatedStates,
      "loading": _vm.showSkeletonLoader || _vm.loading !== false,
      "tileSizeSetting": 1,
      "maxHeight": 305,
      "chartDotRadius": 0,
      "overflow": ""
    },
    on: {
      "didUpdateStates": _vm.didUpdateStates
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };